module.exports = "<button type=\"button\" class=\"btn btn-select-file\" (click)=\"fileInput.click()\">\n  {{buttonText}}\n  <input #fileInput\n         [multiple]=\"!isSingleSelect\"\n         (change)=\"onInputChange($event)\"\n         type=\"file\"\n         [accept]=\"acceptedFileTypes\">\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/select-file/select-file.component.html
// module id = ../../../../../src/app/shared/select-file/select-file.component.html
// module chunks = main